import { useState, useEffect } from "react";
import validateInfo from "./validateInfo";
import {
  EmailAuthProvider,
  createUserWithEmailAndPassword,
  reauthenticateWithCredential,
  signInWithEmailAndPassword,
  updatePassword,
} from "firebase/auth";
import { auth, googleAuthProvider, signInWithPopup } from "../../firebase";
import axios from "axios";

const useForm = (user, setUserInfo, cartItems) => {
  // Login data
  const [loginData, setLoginData] = useState({
    email: "",
    password: "",
  });

  //SignUp data
  const [signUpData, setSignUpData] = useState({
    uid: "",
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    confirmPassword: "",
    dateOfBirth: "",
    gender: "",
    phoneNumber: "",
    shippingAddress: {
      address: "",
      city: "",
      state: "",
      pincode: "",
      country: "India",
    },
    orderHistory: [],
    cartItems: [],
  });

  const [updateUserData, setUpdateUserData] = useState({});
  const [updateNewPassword, setUpdateNewPassword] = useState({});
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [path, setPath] = useState("");
  const [loginError, setLoginError] = useState("");
  const [signUpError, setSignUpError] = useState("");
  const [profileUpdateMessage, setProfileUpdateMessage] = useState("");
  const [passwordUpdateMessage, setPasswordUpdateMessage] = useState({
    successMessage: "",
    errorMessage: "",
  });

  // Updates State's individual values
  const updateValue = (obj, path, value) => {
    const updateObj = { ...obj };
    const pathKeys = path.split(".");
    let currentObj = updateObj;
    for (let i = 0; i < pathKeys.length - 1; i++) {
      const key = pathKeys[i];
      currentObj = currentObj[key];
    }
    const lastKey = pathKeys[pathKeys.length - 1];
    currentObj[lastKey] = value;
    return updateObj;
  };

  // handles change in state on input
  const handleChange = (e, path) => {
    const { name, value } = e.target;
    if (path === "login") {
      const updatedState = updateValue(loginData, name, value);
      setLoginData(updatedState);
    } else if (path === "signUp") {
      if (name === "phoneNumber" && !/^$|^[+-]?\d+$/.test(value)) {
        return;
      }
      const updatedState = updateValue(signUpData, name, value);
      setSignUpData(updatedState);
    }
  };

  const handleShippingAddressChange = (event) => {
    const { name, value } = event.target;
    if (name === "pincode" && !/^$|^[+-]?\d+$/.test(value)) {
      return;
    }
    setSignUpData((signUpData) => ({
      ...signUpData,
      shippingAddress: {
        ...signUpData.shippingAddress,
        [name]: value,
      },
    }));
  };

  const handleSubmit = (e, path) => {
    e.preventDefault();
    setPath(path);
    if (path === "login") {
      setErrors(validateInfo(loginData));
    } else if (path === "signUp") {
      setErrors(validateInfo(signUpData));
    }
    setIsSubmitting(true);
  };

  const handleGoogleSignIn = () => {
    signInWithPopup(auth, googleAuthProvider)
      .then((res) => {
        console.log(res);
        const user = res.user;
        const names = user.displayName.split(" ");
        const firstName = names.slice(0, -1).join(" ");
        const lastName = names[names.length - 1];

        axios
          .post(`${process.env.REACT_APP_BACKEND_LINK}/getgoogleuser`, {
            uid: user.uid,
          })
          .then((res) => {
            console.log(res);
            if (res.data.status === true) {
              // user already exists
              console.log("Existing User");
              setUserInfo(res.data.response);
            } else {
              // new user
              console.log("New User");
              axios
                .post(
                  `${process.env.REACT_APP_BACKEND_LINK}/registeruser`,
                  {
                    uid: user.uid,
                    firstName: firstName,
                    lastName: lastName,
                    email: user.email,
                    dateOfBirth: "",
                    gender: "",
                    phoneNumber:
                      user.phoneNumber !== null ? user.phoneNumber : "",
                    shippingAddress: {
                      address: "",
                      city: "",
                      state: "",
                      pincode: "",
                      country: "India",
                    },
                    orderHistory: [],
                    cartItems: cartItems,
                  },
                  {
                    headers: {
                      "Content-Type": "application/json; charset=UTF-8",
                    },
                  }
                )
                .then((response) => {
                  setUserInfo({
                    uid: user.uid,
                    firstName: firstName,
                    lastName: lastName,
                    email: user.email,
                    dateOfBirth: "",
                    gender: "",
                    phoneNumber:
                      user.phoneNumber !== null ? user.phoneNumber : "",
                    shippingAddress: {
                      address: "",
                      city: "",
                      state: "",
                      pincode: "",
                      country: "India",
                    },
                    orderHistory: [],
                    cartItems: cartItems,
                    password: "",
                    confirmPassword: "",
                  });
                  localStorage.removeItem("ambhosCartItems");
                  // console.log("response", response);
                  // console.log("userInfo", signUpData);
                })
                .catch((err) => console.log(err));
            }
          })
          .catch((error) => {
            // Handle Errors here.
            const errorCode = error.code;
            const errorMessage = error.message;
            // The email of the user's account used.
            //const email = error.customData.email;
            console.log(errorCode, ": ", errorMessage);
          });
      })
      .catch((err) => console.log(err));
  };

  const handleProfileUpdate = (e, userData, path) => {
    e.preventDefault();
    setPath(path);
    setErrors(validateInfo(userData));
    setUpdateUserData(userData);
    setIsSubmitting(true);
  };

  const handleUpdatePassword = (e, updatePasswordData, path) => {
    e.preventDefault();
    setPath(path);
    setErrors(validateInfo(updatePasswordData));
    setUpdateNewPassword(updatePasswordData);
    setIsSubmitting(true);
  };

  useEffect(() => {
    if (Object.keys(errors).length === 0 && isSubmitting) {
      console.log("data sent to server for authentication");
      if (path === "login") {
        // send data
        signInWithEmailAndPassword(auth, loginData.email, loginData.password)
          .then((userCredential) => {
            // Authentication successful
            const authUser = userCredential.user;
            // Get the user.uid and send it to mongodb to get user details and save in userInfo state.
            console.log("Authenticated user:", authUser);
            const uid = authUser.uid;
            axios
              .post(`${process.env.REACT_APP_BACKEND_LINK}/getuserinfo`, {
                uid,
              })
              .then((res) => {
                // console.log("Fetched on login", res);
                setUserInfo(res.data);
              })
              .catch((error) => {
                console.log(error);
              });
          })
          .catch((error) => {
            // Authentication failed
            const errorCode = error.code;
            // const errorMessage = error.message;
            // console.log("Authentication error:", errorCode);
            if (errorCode === "auth/user-not-found") {
              setLoginError("Email Id is not registered.");
            } else if (errorCode === "auth/wrong-password") {
              setLoginError("Wrong Password");
            }
          });
      } else if (path === "signUp") {
        // check if mobileNo is unique
        axios
          .get(
            `${process.env.REACT_APP_BACKEND_LINK}/checkPhoneNumber?phoneNumber=${signUpData.phoneNumber}`
          )
          .then((response) => {
            if (!response.data.exists) {
              // if yes then proceed to create account
              createUserWithEmailAndPassword(
                auth,
                signUpData.email,
                signUpData.password
              )
                .then((userCredential) => {
                  // Signed in
                  const authUser = userCredential.user;
                  // console.log("Registered user:", authUser);
                  // console.log("Fetched Cart Items", cartItems);
                  setSignUpData((signUpData) => ({
                    ...signUpData,
                    uid: authUser.uid,
                    cartItems: cartItems,
                  }));

                  axios
                    .post(
                      `${process.env.REACT_APP_BACKEND_LINK}/registeruser`,
                      { ...signUpData, uid: authUser.uid, cartItems },
                      {
                        headers: {
                          "Content-Type": "application/json; charset=UTF-8",
                        },
                      }
                    )
                    .then((response) => {
                      setUserInfo({
                        ...signUpData,
                        uid: authUser.uid,
                        password: "",
                        confirmPassword: "",
                      });
                      localStorage.removeItem("ambhosCartItems");
                      // console.log("response", response);
                      // console.log("userInfo", signUpData);
                    })
                    .catch((err) => console.log(err));
                })
                .catch((error) => {
                  const errorCode = error.code;
                  const errorMessage = error.message;
                  console.log("Registration error:", errorCode, errorMessage);
                  if (errorCode === "auth/email-already-in-use") {
                    setSignUpError("Email Id is already Registered");
                  }
                });
            } else {
              setSignUpError("Phone Number already Exists");
            }
          })
          .catch((error) => {
            console.log(error);
            setSignUpError("Server Error! Try Again.");
          });
      } else if (path === "profile") {
        axios
          .post(
            `${process.env.REACT_APP_BACKEND_LINK}/updateuserdata`,
            updateUserData
          )
          .then((res) => {
            setProfileUpdateMessage("Successfully Updated");
            setUserInfo(updateUserData);
            // console.log(res);
          })
          .catch((err) => console.log(err));
      } else if (path === "updatePassword") {
        const credential = EmailAuthProvider.credential(
          user.email,
          updateNewPassword.oldPassword
        );
        // Reauthenticate the user
        reauthenticateWithCredential(user, credential)
          .then(() => {
            // Reauthentication successful
            // console.log("Current password is correct.");
            updatePassword(user, updateNewPassword.password)
              .then((res) => {
                setPasswordUpdateMessage({
                  ...passwordUpdateMessage,
                  successMessage: "Password Changed.",
                });
                // console.log("Password Changed - ", res);
              })
              .catch((error) => {
                const errorCode = error.code;
                const errorMessage = error.message;
                console.log(
                  "Password error: ",
                  errorCode,
                  "Message-- ",
                  errorMessage
                );
                if (errorCode === "auth/requires-recent-login") {
                  setPasswordUpdateMessage("Relogin and then try again.");
                }
              });
          })
          .catch((error) => {
            if (error.code === "auth/wrong-password") {
              setPasswordUpdateMessage(
                "Reauthentication failed. Please check your current password."
              );
            } else if (error.code === "auth/too-many-requests") {
              setPasswordUpdateMessage(
                "Access to this account has been temporarily disabled due to many failed login attempts. You can immediately restore it by resetting your password or you can try again later."
              );
            }
            console.log("Reauthentication error:", error.code);
          });
      }
    }
  }, [errors]);

  return {
    handleChange,
    updateValue,
    handleShippingAddressChange,
    handleUpdatePassword,
    loginData,
    signUpData,
    handleSubmit,
    handleProfileUpdate,
    errors,
    loginError,
    signUpError,
    profileUpdateMessage,
    passwordUpdateMessage,
    handleGoogleSignIn,
  };
};

export default useForm;
